import { request } from "./request"

export interface IUpdateFamilyData {
  name?: string
  is_opened?: boolean
 }

export const familyApi = {
  updateFamilyName: (familyId: string, data: IUpdateFamilyData) => {
    return request('PATCH', `/api/2/family_cloud/families/${familyId}/`, data)
  },
} 